import styled from 'styled-components';

export const QNAList = styled.ul`
  margin-top: 10px;

  li {
    padding: 16px 0;
    border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);

    &.noBorder {
      border-bottom: none;
    }
  }
  .question {
    font-size: 13px;
    font-weight: 600;
    color: hsl(0deg, 0%, 0%, 80%);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  p {
    font-size: 13px;
    color: hsl(0deg, 0%, 0%, 60%);
    display: flex;
    align-items: center;
    padding-top: 10px;
  }
`;

export const TopicsList = styled.h5`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ForwardArrow = styled.img`
  transform: rotate(270deg);
  width: 16px;
  height: 16px;
`;

export const ReadMore = styled.span`
  color: #ef4e5e;
  font-weight: 500;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const EllipsisAnswer = styled.span`
  overflow: hidden;
  white-space: nowrap;
  width: 70%;
  display: inline-block;
  text-overflow: ellipsis;
`;
